.downloads {
	display: flex;
	flex-direction: column;
	gap: var(--size-3);

	.download {
		border: var(--size-border-lg) solid var(--color-surface-hover);
		border-radius: var(--radius-lg);
		color: var(--color-text);
		padding: var(--size-4);
		gap: var(--size-4);
		font-size: var(--text-subtitle-2);
		display: flex;
		align-items: center;
		font-weight: 600;

		&:hover,
		&:focus-visible {
			text-decoration: unset;
			background-color: var(--color-surface-hover);
		}
	}
}
